<template>
    <div class="container" id="container">

        <div class="text-center">
            <img class="img-fluid" src="../../public/imagenes/lm-4.png">
        </div>

        <div class="card">
            <div class="card-header">
                <div class="col-xl-12">
                    <div class="text-center d-flex justify-content-center align-items-center">
                                   <h6 class="align-self-end">LECTURA MÓVIL {{ version_app }}.1.5  </h6>
            <!-- <a class="btn btn-primary ml-5 py-1"  href="/prueba"> ir a prueba PWA </a> -->
                    </div>
                </div>
            </div>
            <!-- overlay = opaca el div y muetras un laoding -->
            <b-overlay 
                :show="show" 
                class="d-inline-block">
                <div class="card-body">
                    <div class="form-floating">
                        <input v-model="login"
                        v-bind:class="[camposObligatorios.Login ? 'form-control is-invalid' : 'form-control']"
                            type="text" class="form-control" 
                            id="login"
                            placeholder="Login">
                        <label for="login">Login</label>
                        <span v-if="camposObligatorios.Login"  v-text="camposObligatorios.Login[0]"
                            class="text-danger"></span>
                    </div><br>
                    <div class="form-floating">
                        <input v-model="password"
                            v-bind:class="[camposObligatorios.password ? 'form-control is-invalid' : 'form-control']"
                            :type="type" class="form-control" size="sm" id="contrasena" placeholder="Contraseña">
                        <label for="contrasena">Contraseña</label>
                        <span v-if="camposObligatorios.password" v-text="camposObligatorios.password[0]"
                            class="text-danger"></span>
                    </div>

                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked"
                            @click="showPassword">
                        <label class="form-check-label" for="flexSwitchCheckChecked"> {{ texto }} </label>
                    </div>

                    <br>
                    <div class="d-grid gap-2">
                        <b-button @click="Login()" variant="success">INGRESAR
                        </b-button>
                        <b-button @click="$router.go(0)" variant="primary"> ACTUALIZAR </b-button>
                        <a href="https://api.whatsapp.com/send?phone=59168921251"> Contáctenos </a>
                    </div>
                </div>
            </b-overlay>
        </div>

        <b-modal id="modal-scoped">
            <template #modal-header="{ close }">
                <b-button hidden variant="outline-danger" @click="close()">
                    Cerrar
                </b-button>

                <h5 class="text-danger"> <b-icon icon="x-octagon" scale="2" variant="danger mx-2"></b-icon> Error -
                    {{mensajeHeader}} 
                </h5>
            </template>

            <h5>{{mensajeBody}}</h5>

            <template #modal-footer="{ ok }">
                <b-button block variant="outline-success" @click="ok()">
                    Aceptar
                </b-button>
            </template>
        </b-modal>




    </div>

</template>

<script> 
import LogMovilDAL from '@/DAL/LogMovilDAL';
import { limpiarCache } from '../dataService';
import { getDataBase } from '@/db';
import LecturaNoSubidaDAL from '@/DAL/LecturaNoSubidaDAL';
export default {
    name: 'Login', //nombre del componente
    
    //varibales, inforamcion que se va a mostrar enla vista
    data() {
      return {
        login: '',
        password:'',
        camposObligatorios: [],

        // Alert
        show: false, //pantalla cargando
        mensajeHeader : '',
        mensajeBody : '',

        fecha:'',
        imageEnviar:[],

        // Mostrar contraseña
        type: 'password',
        texto: 'Mostrar Contraseña',

        version_app: ''
      }
    },
    methods:{
        controlErrores(error){
            var array = [];

            if (error.response.status == 422) {
                array = error.response.data.errors
            }else{
                if (error.response.status == 401){
                    this.mensajeHeader = 'Credenciales inválidos';
                    this.mensajeBody = 'Intente nuevamente';
                    this.$bvModal.show('modal-scoped');
                }else{
                    if (error.response.status == 403) {
                    this.mensajeHeader = 'Cuenta suspendida';
                    this.mensajeBody = 'Contactar al Administrador';
                    this.$bvModal.show('modal-scoped');
                    }
                }
            }
            return array;
        },


        Login(){
            
            this.show = true;
            this.axios.post('/login', {
                'Login'    : this.login,
                'password' : this.password
            }).then( async res => {
               
                //agregar plomero a la base de datos 
                const lcNombre = res.data.data.Nombre + ' ' + res.data.data.Apellidos;
                const laPlomeros = await LogMovilDAL.getAll();
                if (laPlomeros.length > 0) {
                    // hay plomero activo
                    //verificar si hay lecturas pendiente 
                    const lnCantidadPendiente = await LecturaNoSubidaDAL.cantidadPendientes();
                    if (lnCantidadPendiente > 0 && res.data.data.Plomero != laPlomeros[0].Plomero ) {

                        //verificar si es el mismo plomero
                        this.mensajeHeader = 'Error al inciar sesión';
                        this.mensajeBody = 'El plomero ' + laPlomeros[0].Nombre + ' tiene ' + lnCantidadPendiente + ' lecturas pendientes. Inicie sesión con ese plomero para poder subir las lecturas pendientes.';
                        this.$bvModal.show('modal-scoped');
                        this.show = false;
                        return; 
                        
                    }else{
                        //verificar si es el mismo plomero
                        if (res.data.data.Plomero != laPlomeros[0].Plomero) {
                            //cambiar plomero
                            await limpiarCache();
                        }
                    }
                }
                
                await LogMovilDAL.updateLogMovil(res.data.data.Plomero, lcNombre);


                this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.token.token;
                localStorage.setItem('token', res.data.token.token);
                localStorage.setItem('NombreUsuario', res.data.data.Nombre);
                localStorage.setItem('ApellidoUsuario', res.data.data.Apellidos);
                localStorage.setItem('EmpresaNombre', res.data.data.EmpresaNombre);
                localStorage.setItem('DataBaseAlias', res.data.data.DataBaseAlias);
                localStorage.setItem('Plomero', res.data.data.Plomero);

                if (!localStorage.getItem('HIDANGER')) localStorage.setItem('HIDANGER', 'danger');
                if (!localStorage.getItem('HGDANGER')) localStorage.setItem('HGDANGER', 'danger');
                    
                
                this.show = false;
                this.$router.push('/menu');

            }).catch(e => {
                console.error('entramos a catch', e);
                
                if (e.response) {
                    this.camposObligatorios = this.controlErrores(e);
                }else{
                    this.mensajeHeader = 'Error de conexión: ' + e.message;
                    this.mensajeBody = 'Intente nuevamente, si el error persiste contacte con soporte';
                    this.$bvModal.show('modal-scoped');
                }   
                this.show = false;
            })
        },

        showPassword() {
            if(this.type == 'password') {
                this.type = 'text'
                this.texto = 'Ocultar Contraseña'
            } else {
                this.type = 'password'
                this.texto = 'Mostrar Contraseña'
            }
        },

        async versionApp(){
            const db = await getDataBase(); // Esperar que la base de datos se haya abierto
            this.version_app = db.version;
        }

    },

    created() {
        this.versionApp();
    }
}
</script>